// ============================================================================
//  Shared content — questionnaire questions + country list.
//  This is the local fallback template; the app also fetches the same
//  template from the backend and de-duplicates by question id.
// ============================================================================

export const questions = [
  {
    id: "goal",
    text: "How can we help you reach your goals?",
    type: "multiple-choice",
    required: true,
    options: ["Lose fat", "Build muscle", "Get stronger", "Improve overall health"],
  },
  {
    id: "sex",
    text: "How do you identify?",
    type: "multiple-choice",
    required: true,
    options: ["Male", "Female", "Prefer not to say"],
  },
  {
    id: "age",
    text: "How old are you?",
    type: "multiple-choice",
    required: true,
    options: ["Under 18", "18-23", "24-29", "30-39", "40-49", "50+"],
  },
  {
    id: "experience",
    text: "What best describes your training experience?",
    type: "multiple-choice",
    required: true,
    options: ["Just getting started", "Some experience", "Very experienced"],
  },
  {
    id: "goal6",
    text: "What's your #1 goal for the next 6 months?",
    type: "text",
    required: true,
  },
  {
    id: "invest",
    text: "Are you prepared to invest in yourself to reach your goals?",
    type: "multiple-choice",
    required: true,
    options: ["Yes, 100%", "I think so", "Not sure yet"],
  },
  {
    id: "budget",
    text: "What does your monthly budget look like?",
    type: "multiple-choice",
    required: true,
    options: ["$100-$200", "$200-$400", "$400-$600", "$600+"],
  },
  {
    id: "firstName",
    text: "What's your first name?",
    type: "text",
    required: true,
  },
  {
    id: "email",
    text: "What's your email address?",
    type: "text",
    required: true,
  },
  {
    id: "phone",
    text: "What's the best phone number to reach you?",
    type: "text",
    required: true,
  },
  {
    id: "country",
    text: "What country are you in?",
    type: "country",
    required: true,
  },
];

export const countries = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda",
  "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain",
  "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia",
  "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso",
  "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic",
  "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia",
  "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic",
  "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini",
  "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana",
  "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras",
  "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy",
  "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea North", "Korea South",
  "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya",
  "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives",
  "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia",
  "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia",
  "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Macedonia",
  "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay",
  "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda",
  "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino",
  "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone",
  "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Sudan",
  "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan",
  "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago",
  "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates",
  "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City",
  "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe",
];
